import './helpers/postDate';
import scrollSmooth from './helpers/smooth-scroll.js';

function main() {
  scrollSmooth();
  new WOW().init();
}

if (document.documentElement.clientWidth < 480) {
  window.addEventListener('scroll',
    function () {
      return setTimeout(main, 1000);
    }, {
      once: true
    });
} else {
  main();
};


// function paralax () {
//   let paralaxElements = document.querySelectorAll('.paralax')
//   document.addEventListener('scroll', function (e) {

//     for(let i = 0; i < paralaxElements.length; i++) {
//         paralaxElements[i].style.transform = 'translateY('+paralaxElements[i].parentElement.getBoundingClientRect().top+'px)'
    
//     }
    
//   })
// }
// paralax ()